import $ from 'jquery';
import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { t, currentLocale } from '../../../lib/i18n';
import colors, { alpha } from '../../../style/colors';
import Reward from '../../../lib/reward';
import ModalDialog from '../../../components/modal-dialog';
import RewardDetails from '../../../components/reward-details';
import ContactConfirmation from './contact-confirmation/contact-confirmation';

const emailRegexp = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;

class ContactForm extends Component {
    state = {};

    constructor() {
        super();
        this.onInputFocus = this.onInputFocus.bind(this);
        this.onInputBlur = this.onInputBlur.bind(this);
    }

    onInputFocus() {
        if (this.props.onInputFocus) { this.props.onInputFocus(); }
    }

    onInputBlur() {
        if (this.props.onInputBlur) { this.props.onInputBlur(); }
    }

    errorFor(fieldName) {
        return this.state.error && this.state.error[fieldName];
    }

    errorClassNameFor(fieldName) {
        return this.errorFor(fieldName) ? 'has-error' : '';
    }

    submit(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.emailField.value.trim()) {
            this.setState({ error: { email: t('contactForm.emailMissing') } });
            return;
        }
        if (!this.emailField.value.match(emailRegexp)) {
            this.setState({ error: { email: t('contactForm.emailInvalid') } });
            return;
        }

        $.ajax({
            url: `${this.props.baseUrl}/api/sdk/support/${this.props.reward.hashKey}`,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({
                comment: this.commentField.value,
                email: this.emailField.value,
                language: currentLocale,
            }),
            success: (result, status, xhr) => {
                if (xhr.status !== 200) {
                    alert(`Could not send feedback: code ${status}`);
                    return;
                }
                this.setState({ feedbackConfirmationShown: true });
            },
            error() {
                alert('Sorry, could not send feedback.');
            },
        });
    }

    render() {
        const reward = this.props.reward;
        if (!reward) {
            return <div />;
        }

        return (
            <div className={this.props.className}>
                {/* <h1>{t('contactForm.title')}</h1> */}

                <RewardDetails reward={reward} />

                <form>
                    <fieldset className={this.errorClassNameFor('email')}>
                        <label htmlFor="email">{t('contactForm.emailLabel')}</label>
                        <span className="error">{this.errorFor('email')}</span>
                        <input
                            // eslint-disable-next-line no-return-assign
                          ref={field => this.emailField = field}
                          onFocus={this.onInputFocus}
                          onBlur={this.onInputBlur}
                          name="email"
                          type="text"
                          placeholder={t('contactForm.emailPlaceholder')}
                        />
                    </fieldset>

                    <fieldset className={this.errorClassNameFor('comment')}>
                        <label htmlFor="comment">{t('contactForm.commentLabel')}</label>
                        <span className="error">{this.errorFor('comment')}</span>
                        <textarea
                          // eslint-disable-next-line no-return-assign
                          ref={field => this.commentField = field}
                          onFocus={this.onInputFocus}
                          onBlur={this.onInputBlur}
                          name="comment"
                          type="comment"
                          placeholder={t('contactForm.commentPlaceholder')}
                        />
                    </fieldset>

                    <button className="send action-button" onClick={e => this.submit(e)}>
                        {t('contactForm.sendButtonLabel')}
                    </button>
                </form>

                <ModalDialog
                  isVisible={this.state.feedbackConfirmationShown}
                  onClose={() => this.props.onClose()}
                  dialogClassName="feedback-confirmation"
                >
                    <ContactConfirmation
                      onGoToOfferButtonClicked={() => {
                          this.setState({ feedbackConfirmationShown: false });
                          this.props.onClose();
                          this.props.onGoToOfferButtonClicked();
                      }}
                    />
                </ModalDialog>
            </div>
        );
    }
}

// Validate all props that are used inside the component to warn early if they're not supplied
// correctly
ContactForm.propTypes = {
    reward: Reward.propTypes,
    installId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    statusData: PropTypes.objectOf(PropTypes.array).isRequired,
    onGoToOfferButtonClicked: PropTypes.func,
    baseUrl: PropTypes.string.isRequired,
    onInputBlur: PropTypes.func,
    onInputFocus: PropTypes.func,
};



const StyledContactForm = styled(ContactForm)`
    .reward-details {
        margin-top: 1em;
    }
    form {
        fieldset {
            border: none;
            margin-top: 0.5em;
            &.has-error {
                label, span.error {
                    color: ${colors.red};
                }
                input, textarea {
                    border: solid 2px ${colors.red};
                }
                span.error {
                    float: right;
                    display: inline-block;
                    font-size: 80%;
                }
            }
        }
        label {
            display: block;
            float: left;
        }
        input, textarea {
            display: block;
            font-size: 1em;
            padding: 0.5em;
            border: solid 2px rgba(0, 0, 0, 0.2);
            width: 100%;
            &:focus {
                background-color: ${alpha(colors.violet, 0.1)};
            }
        }
        textarea {
            height: 180px;
        }
        button.send {
            margin-top: 1em;
            font-size: 1em;
            padding: 0.5em;
            float: right;
        }
    }
`;

export default StyledContactForm;



// WEBPACK FOOTER //
// ./src/pages/status-overview/contact-form/contact-form.jsx